import { render, staticRenderFns } from "./PopupProductSuccess.vue?vue&type=template&id=1c8f2923&scoped=true"
import script from "./PopupProductSuccess.vue?vue&type=script&lang=js"
export * from "./PopupProductSuccess.vue?vue&type=script&lang=js"
import style0 from "./PopupProductSuccess.vue?vue&type=style&index=0&id=1c8f2923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8f2923",
  null
  
)

export default component.exports